import Vue from "vue";

export const store = Vue.observable({
  //共通
  deliveryCd: "",
  userList: []
});
